// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-container {
  height: 100vh;
  background-size: cover;
  height: 100vh;
  font-family: 'Inter';
  color: black;
  gap: 5rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  overflow: scroll;
}

.products {
  border: 0.2rem solid #274e13;
  font-family: Inter;
  color: #274e13;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.products:hover {
  color: white;
  cursor: pointer;
  background-color: #274e13;
}

.orders {
  border: 0.2rem solid #ce7e00;
  font-family: Inter;
  color: #ce7e00;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.orders:hover {
  color: white;
  cursor: pointer;
  background-color: #ce7e00;
}

.settings {
  border: 0.2rem solid;
  font-family: Inter;
  color: #343a40;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.settings:hover {
  color: white;
  cursor: pointer;
  background-color: #343a40;
}

.btn {
  border: none;
  padding: 1.5rem 6rem;
  background-color: rgba(255, 255, 255, 0.899);
  border-radius: 1.5rem;
}

.customer-find-vendor {
  background-color: #e5e7ebe2;
  margin-bottom: 2rem;
  padding: 1.6rem 3.2rem;
  margin-right: 2rem;
  margin-left: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.6rem;
  border-radius: 1.6rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.search-input,
.select-input {
  background-color: #ffffff;
  border: none;
  border-radius: 100rem;
  padding: 1rem;
  margin-left: 1rem;
  font-size: 1.4rem;
  width: 20rem;
}

.customer-view-items-display {
  grid-area: customer-view-item-card;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.customer-view-item-card {
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /* border: 3px solid black; */
  margin: 2rem;
  padding: 1.5rem;
  border-radius: 5px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.3);
  background-color: #e5e7ebe2;
  align-items: center;
  justify-content: space-between;
}

.customer-item-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 50%;
  margin-bottom: 1rem;
}

img {
  border-radius: 15px;
  max-width: 20rem;
  height: 100%;
  object-fit: cover;
  margin-right: 1rem;
}

.purchase-btn {
  padding: 8px 15px;
  cursor: pointer;
  background-color: #274e13;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.4rem;
}

.purchase-btn:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: left;
  align-items: center;
  width: 65%;
}

.item-name {
  font-size: larger;
  font-weight: bold;
  text-transform: uppercase;
}

.quantity-num {
  text-align: center;
  font-size: 1.4rem;
  height: 3.5rem;
  width: 3.5rem;
}

.quantity-btn {
  height: 3rem;
  width: 3rem;
  margin: 1rem;
}

.quantity-order-btn-container {
  display: flex;
}

.selected-vendor {
  font-size: 1.8rem;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: scroll;
}

.close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
}

.modal-input-cc {
  width: 40%;
}

.modal-input-cc-ex {
  width: 20%;
}

.modal-input-cc-cvv {
  width: 20%;
}

.invoice-header {
  font-size: 3.2rem;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.invoice-invoice-num {
  font-size: 1.8rem;
}

.invoice-info {
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.invoice-total {
  font-size: 1.8rem;
}

.invoice-payment-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 1.2rem;
}

.order-confirm-btn {
  margin-top: 2rem;
  border-radius: 100rem;
  padding: 1rem 4rem;
  border: none;
  background-color: #37513e;
  color: white;
  font-weight: bold;
  font-size: 1.4rem;
}

.order-confirm-btn:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

.details-invoice {
  max-height: 4rem;
  overflow: scroll;
}

.printer-icon {
  height: 4rem;
  width: 4rem;
}

.printer-icon:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

@media (max-width: 1077px) {
  .add-item-item-name,
  .add-item-item-size,
  .add-item-item-price,
  .add-item-item-quantity,
  .add-item-item-notes {
    font-size: 1.2rem;
  }

  .customer-view-items-display {
    grid-area: customer-view-item-card;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .add-item-form {
    gap: 1rem;
  }
  .post-btn {
    font-size: 1.2rem;
  }
  .quantity-input {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 711px) {
  .item-details {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 1.2rem;
  }

  .customer-view-items-display {
    grid-area: customer-view-item-card;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 369px) {
  .customer-view-item-card {
    flex-direction: column;
  }
  .item-details {
    margin: 10%;
  }

  .customer-view-items-display {
    grid-area: customer-view-item-card;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}

.customer-view-card-details {
  font-style: italic;
  max-height: 5rem;
  overflow: auto;
}

.customer-view-card-details::-webkit-scrollbar {
  width: 12px;
}

.customer-view-card-details::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;
}

.customer-view-card-details::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerDashboard/CustomerDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE;;;;;IAKE,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,qCAAqC;EACvC;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".customer-container {\n  height: 100vh;\n  background-size: cover;\n  height: 100vh;\n  font-family: 'Inter';\n  color: black;\n  gap: 5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  overflow: scroll;\n}\n\n.products {\n  border: 0.2rem solid #274e13;\n  font-family: Inter;\n  color: #274e13;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.products:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #274e13;\n}\n\n.orders {\n  border: 0.2rem solid #ce7e00;\n  font-family: Inter;\n  color: #ce7e00;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.orders:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #ce7e00;\n}\n\n.settings {\n  border: 0.2rem solid;\n  font-family: Inter;\n  color: #343a40;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.settings:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #343a40;\n}\n\n.btn {\n  border: none;\n  padding: 1.5rem 6rem;\n  background-color: rgba(255, 255, 255, 0.899);\n  border-radius: 1.5rem;\n}\n\n.customer-find-vendor {\n  background-color: #e5e7ebe2;\n  margin-bottom: 2rem;\n  padding: 1.6rem 3.2rem;\n  margin-right: 2rem;\n  margin-left: 2rem;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.6rem;\n  border-radius: 1.6rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.search-input,\n.select-input {\n  background-color: #ffffff;\n  border: none;\n  border-radius: 100rem;\n  padding: 1rem;\n  margin-left: 1rem;\n  font-size: 1.4rem;\n  width: 20rem;\n}\n\n.customer-view-items-display {\n  grid-area: customer-view-item-card;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.customer-view-item-card {\n  font-size: 1.4rem;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  /* border: 3px solid black; */\n  margin: 2rem;\n  padding: 1.5rem;\n  border-radius: 5px;\n  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.3);\n  background-color: #e5e7ebe2;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.customer-item-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80%;\n  height: 50%;\n  margin-bottom: 1rem;\n}\n\nimg {\n  border-radius: 15px;\n  max-width: 20rem;\n  height: 100%;\n  object-fit: cover;\n  margin-right: 1rem;\n}\n\n.purchase-btn {\n  padding: 8px 15px;\n  cursor: pointer;\n  background-color: #274e13;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1.4rem;\n}\n\n.purchase-btn:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n.item-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: left;\n  align-items: center;\n  width: 65%;\n}\n\n.item-name {\n  font-size: larger;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.quantity-num {\n  text-align: center;\n  font-size: 1.4rem;\n  height: 3.5rem;\n  width: 3.5rem;\n}\n\n.quantity-btn {\n  height: 3rem;\n  width: 3rem;\n  margin: 1rem;\n}\n\n.quantity-order-btn-container {\n  display: flex;\n}\n\n.selected-vendor {\n  font-size: 1.8rem;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow: scroll;\n}\n\n.close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 30px;\n  cursor: pointer;\n}\n\n.modal-input-cc {\n  width: 40%;\n}\n\n.modal-input-cc-ex {\n  width: 20%;\n}\n\n.modal-input-cc-cvv {\n  width: 20%;\n}\n\n.invoice-header {\n  font-size: 3.2rem;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.invoice-invoice-num {\n  font-size: 1.8rem;\n}\n\n.invoice-info {\n  font-size: 1.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.invoice-total {\n  font-size: 1.8rem;\n}\n\n.invoice-payment-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 1.2rem;\n}\n\n.order-confirm-btn {\n  margin-top: 2rem;\n  border-radius: 100rem;\n  padding: 1rem 4rem;\n  border: none;\n  background-color: #37513e;\n  color: white;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.order-confirm-btn:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n.details-invoice {\n  max-height: 4rem;\n  overflow: scroll;\n}\n\n.printer-icon {\n  height: 4rem;\n  width: 4rem;\n}\n\n.printer-icon:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n@media (max-width: 1077px) {\n  .add-item-item-name,\n  .add-item-item-size,\n  .add-item-item-price,\n  .add-item-item-quantity,\n  .add-item-item-notes {\n    font-size: 1.2rem;\n  }\n\n  .customer-view-items-display {\n    grid-area: customer-view-item-card;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .add-item-form {\n    gap: 1rem;\n  }\n  .post-btn {\n    font-size: 1.2rem;\n  }\n  .quantity-input {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media (max-width: 711px) {\n  .item-details {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    font-size: 1.2rem;\n  }\n\n  .customer-view-items-display {\n    grid-area: customer-view-item-card;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 369px) {\n  .customer-view-item-card {\n    flex-direction: column;\n  }\n  .item-details {\n    margin: 10%;\n  }\n\n  .customer-view-items-display {\n    grid-area: customer-view-item-card;\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.customer-view-card-details {\n  font-style: italic;\n  max-height: 5rem;\n  overflow: auto;\n}\n\n.customer-view-card-details::-webkit-scrollbar {\n  width: 12px;\n}\n\n.customer-view-card-details::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 6px;\n}\n\n.customer-view-card-details::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
